export const notificationDuration: number = 5000;
